/**
This is adapted from
https://github.com/svecosystem/runed/tree/main
MIT LICENSE:
https://github.com/svecosystem/runed/blob/main/LICENSE
*/
import { extract } from '@vpap_svelte/internal';
/**
 * Reports an element's dimensions, updating them as they change
 */
export function useResizeObserver(target, callback, options = {}) {
    let observer;
    let rawTarget = $derived(extract(target));
    const targets = $derived(new Set(rawTarget ? (Array.isArray(rawTarget) ? rawTarget : [rawTarget]) : []));
    const stop = $effect.root(() => {
        $effect(() => {
            if (!targets.size)
                return;
            observer = new ResizeObserver(callback);
            for (const el of targets) {
                observer.observe(el, options);
            }
            return () => {
                observer?.disconnect();
                observer = undefined;
            };
        });
    });
    $effect(() => {
        return stop;
    });
    return {
        stop,
    };
}
